export const HTML_TAG_REMOVE_REGEX = /<\/*[^<^>]+>/gi;
export const MARKDOWN_HYPERLINK_REGEX = /\[([^\]]+)\]\((?!https?:\/\/)([^)]+)\)/gi;
export const EDITOR_UPDATE_DELAY = 200;
